export default __webpack_public_path__ + "static/media/vehicale-tracking.8e25ce4e.png";